import React from 'react';

import { pageTitle as pageTitleService } from 'services/pageTitle';

import { useProjectTreeStore } from 'store/projectContract.store';

import { useQueryGetProgramGeneralHierarchyList } from 'api/queries/getProgramGeneralHierarchyList.query';

import { TreeCrumbs } from 'components/common/TreeCrumbs/TreeCrumbs';

import classes from './TopHeaderCustomComponent.module.scss';

type Props = {
    pageTitle: string;
};

export const TopHeaderCustomComponent = ({ pageTitle }: Props) => {
    pageTitle.length > 0 && pageTitleService.set(pageTitle);
    const { data: projectHierarchyList } = useQueryGetProgramGeneralHierarchyList('TreeProgramFilter');
    const { project: storedProject } = useProjectTreeStore();
    const list = projectHierarchyList
        ? {
              ...projectHierarchyList,
              children: projectHierarchyList?.children.map((item) => ({ ...item, children: null })),
          }
        : undefined;

    const rest: { id?: string } = {};
    if (pageTitle) {
        rest.id = 'page-title';
    }

    return (
        <div className={classes.treeProgramTopHeader}>
            <div className={classes.headerContent}>
                {list && (
                    <TreeCrumbs
                        selectedNode={storedProject?.uuid}
                        data={list}
                        showAddNewButton={false}
                        showAll={false}
                        isDisabled={true}
                    />
                )}
            </div>
        </div>
    );
};
